import React from 'react';
import PropTypes from 'prop-types';
import { Card, Col, Row } from 'react-bootstrap';
import FalconCardHeader from 'components/common/FalconCardHeader';
import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import SimpleBarReact from 'simplebar-react';
import { Link } from 'react-router-dom';
import { faFileInvoice } from '@fortawesome/free-solid-svg-icons';

const Previsao = ({
  previsao: {
    id,
    processo,
    data,
    modalidade,
    destino,    
    referencia
  },
  isLast,
  operacao
}) => {
  // let sigla = operacao === 'Agenciamento' ? 'A' :
  //   operacao === 'Exportação' ? 'E' : 'I';
  return (
    <Row className="g-3 pb-s1">
      <Col>
        <Row
          className={classNames('g-3', { 'mb-3 border-bottom pb-s1': !isLast })}
        >
          <Col xs={2} sm={1} className="d-flex justify-content-center">
            <FontAwesomeIcon
              icon={classNames({
                plane: ['Aereo', 'AÉREO', 'Aéreo'].includes(modalidade),
                truck: ['RODOVIÁRIO', 'Rodoviário', 'RODOVIARIO'].includes(
                  modalidade
                ),
                ship: [
                  'Marítimo',
                  'Maritimo',
                  'MARITIMA',
                  'MARÍTIMO (LCL)',
                  'MARÍTIMO (FCL)',
                  'BREAK BULK'
                ].includes(modalidade)
              })}
              size="lg"
            />
          </Col>
          <Col xs={5} sm={2}>
            <h6
              className="text-800 mb-1 text-center"
              style={{ fontSize: '0.625em' }}
            >
              {processo}
            </h6>
          </Col>
          <Col xs={7} sm={4}>
            <h6
              className="text-800 mb-1 text-center"
              style={{ fontSize: '0.625em' }}
            >
              {referencia}
            </h6>
          </Col>
          <Col xs={5} sm={2}>
            <h6
              className="text-600 mb-1 text-center"
              style={{ fontSize: '0.625em' }}
            >
              {data}
            </h6>
          </Col>
          <Col xs={5} sm={2}>
            <h6
              className="text-600 mb-1 text-center"
              style={{ fontSize: '0.625em' }}
            >
              {destino}
            </h6>
          </Col>
          <Col
            xs={2}
            sm={1}
            className="d-flex justify-content-center align-items-center"
          >
            <Link
              to={{
                pathname: `/app/process/process-details/${operacao}&${id}`
              }}
            >
              <FontAwesomeIcon
                icon={faFileInvoice}
                title="Detalhes"
                style={{ cursor: 'pointer' }}
                size="lg"
              />
            </Link>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

const PrevisaoChegada = ({ data, title, operacao }) => {
  let tpoperacoes =
    operacao === 'AGENCIAMENTO' ? 'A' : operacao === 'IMPORTAÇÃO' ? 'I' : 'E';
  return (
    <Card className="h-100 recent-activity-card">
      <FalconCardHeader title={title} titleTag="h6" />
      <SimpleBarReact style={{ height: '26rem', overflow: 'auto' }}>
        <Card.Body className="ps-2 recent-activity-body-height">
           {Array.isArray(data) && data.length > 0 ? (
          <Row className="g-3 pb-s1">
            <Col>
              <Row className="g-3 mb-3 border-bottom pb-s1">
                <Col xs={2} sm={1}>
                  <h6
                    className="text-800 mb-1 text-center"
                    style={{ fontSize: '0.625em' }}
                  >
                    Modal
                  </h6>
                </Col>
                <Col xs={4} sm={2}>
                  <h6
                    className="text-800 mb-1 text-center"
                    style={{ fontSize: '0.625em' }}
                  >
                    Processo
                  </h6>
                </Col>
                <Col xs={6} sm={4}>
                  <h6
                    className="text-800 mb-1 text-center"
                    style={{ fontSize: '0.625em' }}
                  >
                    Referencia
                  </h6>
                </Col>
                <Col xs={4} sm={2}>
                  <h6
                    className="text-600 mb-1 text-center"
                    style={{ fontSize: '0.625em' }}
                  >
                    Data
                  </h6>
                </Col>
                <Col xs={4} sm={2}>
                  <h6
                    className="text-600 mb-1 text-center"
                    style={{ fontSize: '0.625em' }}
                  >
                    Destino
                  </h6>
                </Col>
                <Col
                  xs={1}
                  className="d-flex justify-content-center align-items-center"
                ></Col>
              </Row>
            </Col>
          </Row>
           ):(
            <div className="text-center p-3">Sem previsões</div>
           )}
          {data.map((previsao, index) => (
            <Previsao
              key={previsao.processo}
              previsao={previsao}
              isLast={index === data.length - 1}
              operacao={tpoperacoes}
            />
          ))}
        </Card.Body>
      </SimpleBarReact>
    </Card>
  );
};

Previsao.propTypes = {
  previsao: PropTypes.shape({
    id: PropTypes.number,
    processo: PropTypes.string.isRequired,
    data: PropTypes.string.isRequired,
    modalidade: PropTypes.string.isRequired,
    destino: PropTypes.string.isRequired,
    title: PropTypes.string,
    referencia: PropTypes.string.isRequired
  }),
  isLast: PropTypes.bool,
  operacao: PropTypes.string.isRequired
};

PrevisaoChegada.propTypes = {
  data: PropTypes.arrayOf(Previsao.propTypes.previsao),
    operacao: PropTypes.string
};

export default PrevisaoChegada;
